import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import styles from "./styles.scss";

function Header({ action }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.header}>
      <h3 className={classNames(styles.label, styles.resource)}>
        {t("taskRetrieval.allocations.resource")}
      </h3>
      <h3 className={classNames(styles.label, styles.column)}>
        {t("taskRetrieval.allocations.allocatedHours")}
      </h3>
      <h3 className={classNames(styles.label, styles.column)}>
        {t("taskRetrieval.allocations.spentHours")}
      </h3>
      <h3 className={classNames(styles.label, styles.column)}>
        {t("taskRetrieval.allocations.progress")}
      </h3>
      <div className={styles.actionSlot}>{action}</div>
    </div>
  );
}

export { Header };
